import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import SearchForm from './SearchForm';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { updateBulkCopyCheckboxState,initSelectedList } from "./service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Jobs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            jobs: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            from: '',
            to: '',
            total: '',
            jobIds: [],
            me: [],
            defaultPublicationType: 1,
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleDateAndTimeType = this.handleDateAndTimeType.bind(this);
        this.handlePeriodType = this.handlePeriodType.bind(this);
        this.handleChangeCheckBoxBulkCopy = this.handleChangeCheckBoxBulkCopy.bind(this);
        this.handleBulkCopy = this.handleBulkCopy.bind(this);
        this.handleBulkCheck = this.handleBulkCheck.bind(this);
        if (props.jobs && props.jobs.length) {
            this.props.dispatch(
                initSelectedList(Object.assign({}))
            );
        }
    }

    /**
     * Init data and form job or list jobs
     */
    componentWillMount() {
        axios.get('/api/me').then(response => {
            this.setState({
                defaultPublicationType: response.data.default_publication_type
            })
            const keySearch_str = this.props.location.search.substring(1);
            let keySearch_arr = {page: 1};
            if (keySearch_str) {
                keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
            }
            if(!keySearch_arr.publication_type) {
                keySearch_arr.publication_type = response.data.default_publication_type;
            }
            //always get list data
            axios.post('/api/houjin/jobs/search', keySearch_arr).then(response => {
                this.prepareRender(response.data.data);
                this.setState({
                    jobs: response.data.data,
                    lastPage: response.data.last_page,
                    currentPage: response.data.current_page,
                    searchConditions: keySearch_arr,
                    from: response.data.from,
                    to: response.data.to,
                    total: response.data.total,
                });
                this.props.history.push({
                    search: keySearch_str
                });
            });
        })

    }

    /**
     * Prepare render jobs
     */
    prepareRender(response) {
        response.map((job) => {
            if (job.work_start_time == '00:00:00' && job.work_end_time == '23:59:00') {
                //job.work_date_time = '時間指定なし';
                job.work_date_time = job.work_start_date.replace(/-/g, '/');
            }
        })
    }

    componentDidMount(){
        //alert after successfull action
        if(this.props.history.location.state && this.props.history.location.state.message_success){
            toast.success(this.props.history.location.state.message_success)
        }
    }

    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/houjin/jobs/search', newSearchConditions).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }

    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/houjin/jobs/search', key).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }
    handleDateAndTimeType() {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.publication_type = 1;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/houjin/jobs/search', newSearchConditions).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    handlePeriodType() {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.publication_type = 2;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/houjin/jobs/search', newSearchConditions).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobs: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }

    /**
     * Edit job
     * job: Object Client
     */
    handleEdit(job) {
        this.props.history.push('/houjin/jobs/edit/' + job.id);
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    handleChangeCheckBoxBulkCopy(e, job) {

        let newJobIds = [...this.state.jobIds];
        if(newJobIds.includes(job.id)) {
            newJobIds = newJobIds.filter(
                (checkedValue) => checkedValue !== job.id
            )
        } else {
            newJobIds.push(job.id)
        }
        this.setState({jobIds:newJobIds})
        this.props.dispatch( updateBulkCopyCheckboxState(Object.assign({}, {selectedJobIds:newJobIds})) );
    }
    handleBulkCopy() {
        this.props.history.push('/houjin/jobs/copy');
    }
    handleBulkCheck(e) {
        if (this.state.jobs.length) {
            if (e.target.checked) {
                let jobIds = []
                this.state.jobs.map((job, i) => {
                    jobIds.push(job.id)
                })
                this.setState({jobIds:jobIds})
                this.props.dispatch( updateBulkCopyCheckboxState(Object.assign({}, {selectedJobIds:jobIds})) );
            } else {
                let jobIds = []
                this.setState({jobIds:jobIds})
                this.props.dispatch( updateBulkCopyCheckboxState(Object.assign({}, {selectedJobIds:jobIds})) );
            }
        }
    }

    render() {
        const option = {
            1:{text:'掲載中',classHTML:'text-primary'},
            2:{text:'掲載終了',classHTML:'text-pink'},
            3:{text:'就業中',classHTML:'text-info'},
            4:{text:'評価待ち',classHTML:'text-warning'},
            5:{text:'作業完了',classHTML:'text-teal'},
            6:{text:'未採用',classHTML:'text-gray'},
            7:{text:'仲裁',classHTML:'text-pink'},
            8:{text:'欠勤',classHTML:'text-primary'},
            9:{text:'依頼キャンセル',classHTML:'text-gray'},
            0:{text:'掲載確認',classHTML:'text-gray'},
            null:{text:'掲載確認',classHTML:'text-gray'}
        };
        const colorRows = {
            1:'table-primary',
            2:'table-danger',
            3:'table-info',
            4:'table-warning',
            5:'table-success',
            6:'table-dark',
            7:'table-light',
            8:'table-light',
            9:'table-dark',
            null:'table-light'
        };
        const optionTR = {
            colors : colorRows,
            conditionColumn: 'status'
        }
        const columns = this.state.searchConditions.publication_type == 2 ? [
                {name: 'id', title: 'No.', isSort: 1, type: 'text'},
                //{name: 'first_last_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
                {name: 'categories_name', title: '依頼名', isSort: 1, type: 'text_break_line', isSearch:true},
                {name: 'status', title: '状態', isSort: 1, type: 'status_option', option:option},
                {name: 'work_date_time', title: '期間と時間帯', isSort: 1, type: 'text_break_line', isSearch:true},
                {name: 'adopted_apply_date', title: '作業予定日', isSort: 0, type: 'text_break_line', isSearch:true},
                // {name: 'day_left', title: '配置完了締切', isSort: 0, type: 'text'},
                {name: 'staff_price', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero'},
                {name: 'staff_count', title: '募集', isSort: 1, type: 'text'},
                {name: 'apply_count', title: '応募', isSort: 1, type: 'text'},
                {name: 'recruit_count', title: '採用', isSort: 1, type: 'text'},
                {name: 'absenteeism_count', title: '欠勤', isSort: 1, type: 'text'},
                {name: 'bulk_copy', title: '一括コピー', isSort: 0, type: 'checkbox_bulk_copy'},
                //{name: 'evaluationAvg', title: '依頼者評価', isSort: 1, type: 'text'},
            ] : [
                    {name: 'id', title: 'No.', isSort: 1, type: 'text'},
                    //{name: 'first_last_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
                    {name: 'categories_name', title: '依頼名', isSort: 1, type: 'text_break_line', isSearch:true},
                    {name: 'status', title: '状態', isSort: 1, type: 'status_option', option:option},
                    {name: 'work_date_time', title: '勤務日時', isSort: 1, type: 'text_break_line', isSearch:true},
                    // {name: 'day_left', title: '配置完了締切', isSort: 0, type: 'text'},
                    {name: 'staff_price', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero'},
                    {name: 'staff_count', title: '募集', isSort: 1, type: 'text'},
                    {name: 'apply_count', title: '応募', isSort: 1, type: 'text'},
                    {name: 'recruit_count', title: '採用', isSort: 1, type: 'text'},
                    {name: 'absenteeism_count', title: '欠勤', isSort: 1, type: 'text'},
                    //{name: 'evaluationAvg', title: '依頼者評価', isSort: 1, type: 'text'},
                ]

        // const columns = [
        //     {name: 'id', title: 'No.', isSort: 1, type: 'text'},
        //     //{name: 'first_last_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
        //     {name: 'categories_name', title: '依頼名', isSort: 1, type: 'text_break_line', isSearch:true},
        //     {name: 'work_date_time', title: '勤務日時', isSort: 1, type: 'text_break_line', isSearch:true},
        //     {name: 'day_left', title: '配置完了締切', isSort: 0, type: 'text'},
        //     {name: 'status', title: '状態', isSort: 1, type: 'status_option', option:option},
        //     {name: 'staff_price', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero'},
        //     {name: 'staff_count', title: '募集', isSort: 1, type: 'text'},
        //     {name: 'apply_count', title: '応募', isSort: 1, type: 'text'},
        //     {name: 'recruit_count', title: '採用', isSort: 1, type: 'text'},
        //     {name: 'absenteeism_count', title: '欠勤', isSort: 1, type: 'text'},
        //     //{name: 'evaluationAvg', title: '依頼者評価', isSort: 1, type: 'text'},
        // ]
        // 日時指定
        // [
        //     {name: 'id', title: 'No.', isSort: 1, type: 'text'},
        //     //{name: 'first_last_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
        //     {name: 'categories_name', title: '依頼名', isSort: 1, type: 'text_break_line', isSearch:true},
        //     {name: 'work_date_time', title: '勤務日時', isSort: 1, type: 'text_break_line', isSearch:true},
        //     {name: 'day_left', title: '配置完了締切', isSort: 0, type: 'text'},
        //     {name: 'status', title: '状態', isSort: 1, type: 'status_option', option:option},
        //     {name: 'staff_price', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero'},
        //     {name: 'staff_count', title: '募集', isSort: 1, type: 'text'},
        //     {name: 'apply_count', title: '応募', isSort: 1, type: 'text'},
        //     {name: 'recruit_count', title: '採用', isSort: 1, type: 'text'},
        //     {name: 'absenteeism_count', title: '欠勤', isSort: 1, type: 'text'},
        //     //{name: 'evaluationAvg', title: '依頼者評価', isSort: 1, type: 'text'},
        // ]
        // 期間指定
        // [
        //     {name: 'id', title: 'No.', isSort: 1, type: 'text'},
        //     //{name: 'first_last_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
        //     {name: 'categories_name', title: '依頼名', isSort: 1, type: 'text_break_line', isSearch:true},
        //     {name: 'status', title: '状態', isSort: 1, type: 'status_option', option:option},
        //     {name: 'work_date_time', title: '期間と時間帯', isSort: 1, type: 'text_break_line', isSearch:true},
        //     //{name: 'day_left', title: '配置完了締切', isSort: 0, type: 'text'},
        //     {name: 'staff_price', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero'},
        //     {name: 'staff_count', title: '募集', isSort: 1, type: 'text'},
        //     {name: 'apply_count', title: '応募', isSort: 1, type: 'text'},
        //     {name: 'recruit_count', title: '採用', isSort: 1, type: 'text'},
        //     {name: 'absenteeism_count', title: '欠勤', isSort: 1, type: 'text'},
        //     //{name: 'evaluationAvg', title: '依頼者評価', isSort: 1, type: 'text'},
        // ]
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">依頼一覧</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-4">
                                            <h4 className="mt-2 mb-0 page-title">依頼一覧</h4>
                                        </div>
                                        <div className="col-8 text-right pr-0">
                                            {/* TODO:仮リンク */}
                                            {/* <a onClick={this.handleDateAndTimeType} className="btn btn-warning btn-space">日時指定</a>
                                            <a onClick={this.handlePeriodType} className="btn btn-warning btn-space">期間指定</a> */}
                                            {/* <button onClick={(e) => this.handleBulkCheck(e)} className="btn btn-warning btn-space">一括チェック</button> */}
                                            <a onClick={this.handleRedirect} href="/houjin/jobs/create" className="btn btn-warning btn-space">依頼登録</a>
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search_order" aria-expanded="false" aria-controls="search_order">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <ul className="nav nav-tabs">
                                    <li className="nav-item text-center">
                                        {
                                            this.state.searchConditions.publication_type == 1 ? (
                                                <a className="nav-link active" aria-current="page" onClick={this.handleDateAndTimeType}>日時指定型</a>
                                            ): (
                                                <a className="nav-link" onClick={this.handleDateAndTimeType}>日時指定型</a>
                                            )
                                        }
                                    </li>
                                    <li className="nav-item text-center">
                                        {
                                            this.state.searchConditions.publication_type == 1 ? (
                                                <a className="nav-link" onClick={this.handlePeriodType}>期間指定型</a>
                                            ): (
                                                <a className="nav-link active" aria-current="page" onClick={this.handlePeriodType}>期間指定型</a>
                                            )
                                        }
                                    </li>
                                {
                                    this.state.searchConditions.publication_type == 1 ? '' : (
                                    <li className="nav-item-checkbutton">
                                        <div className="d-flex justify-content-end">
                                            <div className="col-5 d-flex justify-content-end text-right pb-2">
                                                <div className="checkbutton d-none d-md-block">
                                                    <div className="form-check">
                                                        <input onClick={(e) => this.handleBulkCheck(e)} className="form-check-input" type="checkbox" value="1" id="bulkcheck" checked={ this.state.jobIds.length == this.state.jobs.length } />
                                                        <label className="form-check-label" for="bulkcheck">
                                                            <p>全て選択</p>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )}

                                </ul>
                                <Table optionTR={optionTR} onSearch={this.handleSearch} onSort={this.handleSort} onEdit={this.handleEdit} onChangeCheckBoxBulkCopy={this.handleChangeCheckBoxBulkCopy} onBulkCopy={ this.handleBulkCopy } header={columns} data={this.state.jobs}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} from={this.state.from} to={this.state.to} total={this.state.total} />
                            </div>
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        );
    }

}
const mapStateToProps = state => {
    const {selectedJobIds,jobs} = state.job
    return {
        selectedJobIds: selectedJobIds,
        jobs: jobs,
    }
}

export default withRouter(connect(mapStateToProps)(Jobs))
